module.exports = __webpack_public_path__ + "img/48_12.b80eb4e0.png";